import { connect } from 'react-redux';
import * as ReportPortalActions from '../../Actions/ReportPortalActions';
import ReportExportNotification from '../../Components/AryaNotifications/ReportExportNotification/ReportExportNotification';

const mapDispatchToProps = {
  downloadReport: ReportPortalActions.downloadReport,
};

export default connect(null, mapDispatchToProps)(ReportExportNotification);
